import { render } from "./SaveNotifyUser.vue?vue&type=template&id=5468b067&scoped=true&ts=true"
import script from "./SaveNotifyUser.vue?vue&type=script&lang=ts"
export * from "./SaveNotifyUser.vue?vue&type=script&lang=ts"

import "./SaveNotifyUser.vue?vue&type=style&index=0&id=5468b067&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5468b067"]])

export default __exports__